import React from 'react';

export const LayoutContext = React.createContext();
export const HeightContext = React.createContext();
